angular
  .module('contrast.services.organization.attacksearch', [])
  .factory('AttackSearchService', function () {
    return {
      setIndex: function (index) {
        this.index = index
      },
      getIndex: function () {
        return this.index
      },
      setUUIDs: function (uuids) {
        this.uuids = uuids
      },
      getUUIDs: function () {
        return this.uuids
      }
    }
  })
